import type { ReactNode } from "react";
import { Icon, type IconName } from "../components/Icon";
import { defineStrings, useStrings } from "../i18n";

const strings = defineStrings(
  { progress: "Progress", attention: "Needs attention", info: "Good to know" },
  { progress: "Progression", attention: "À surveiller", info: "Bon à savoir" },
);

export type InsightTone = "progress" | "attention" | "info";

export interface InsightCardProps {
  readonly tone: InsightTone;
  readonly title: string;
  readonly body: string;
  readonly children?: ReactNode;
}

const icons: Readonly<Record<InsightTone, IconName>> = {
  progress: "sparkle",
  attention: "alert",
  info: "info",
};

/** One insight for a parent. The tone is shown by an icon and a word, never colour alone. */
export function InsightCard(props: InsightCardProps) {
  const t = useStrings(strings);
  return (
    <article className="p-insight" data-tone={props.tone}>
      <p className="p-insight__tone">
        <Icon name={icons[props.tone]} size={18} className="p-insight__icon" />
        <span>{t(props.tone)}</span>
      </p>
      <h3 className="p-insight__title">{props.title}</h3>
      <p className="p-insight__body">{props.body}</p>
      {props.children !== undefined && <div className="p-insight__extra">{props.children}</div>}
    </article>
  );
}
